import { Component, Input } from '@angular/core';
import { Color, ScaleType } from '@swimlane/ngx-charts';

@Component({
    selector: 'app-conv-emotion-chart',
    templateUrl: './conv-emotion-chart.component.html',
    styleUrl: './conv-emotion-chart.component.scss',
    standalone: false
})
export class ConvEmotionChartComponent {
	// options
	legend = false;
	animations = false;
	xAxis = true;
	yAxis = false;
	showYAxisLabel = false;
	showXAxisLabel = true;
	min = 0;
	max = 100;
	colorScheme: string | Color = {
		name: 'myScheme',
		selectable: true,
		group: ScaleType.Ordinal,
		domain: ['transparent', '#15A607', '#F1D50A', '#F1960A', '#F11C0A'],
	};

	series = [
		{ name: 'Threatened', value: true },
		{ name: 'Excited', value: true },
		{ name: 'Insecure', value: true },
		{ name: 'Positive', value: true },
		{ name: 'Frustration', value: true },
		{ name: 'Rejection', value: true },
	]

	@Input() emotionData: any[] = [];

	chartData: any[] = [];
	ready = false;

	showHeatmap() {
		this.ready = true;
		this.calculateHeatMapData(20);
	}

	calculateHeatMapData(currentTime: number) {
		const start = currentTime - 20;
		const dataChart = [];

		for (let index = start; index <= currentTime; index++) {
			const time = this.convertToTimerFormat(index);

			let threatened = 0;
			let excited = 0;
			let insecure = 0;
			let positive = 0;
			let frustration = 0;
			let rejection = 0;

			if (index < this.emotionData.length) {
				switch (this.emotionData[index].emotion) {
					case 'angry':
						threatened = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
					case 'surprise':
						excited = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
					case 'fear':
						insecure = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
					case 'happy':
						positive = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
					case 'sad':
						frustration = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
					case 'disgust':
						rejection = +(this.emotionData[index].confidence*100).toFixed(2);
						break;
				}
			}

			const data = {
				name: time,
					series: [
						{ name: 'Threatened', value: threatened },
						{ name: 'Excited', value: excited },
						{ name: 'Insecure', value: insecure },
						{ name: 'Positive', value: positive },
						{ name: 'Frustration', value: frustration },
						{ name: 'Rejection', value: rejection },
					]
			};

			dataChart.push(data);
		}

		this.chartData = [...dataChart];

		if (!this.ready) {
			this.ready = true;
		}
	}

	updateHeatmap(currentTime: number) {
		if (currentTime > 20) {
			this.calculateHeatMapData(currentTime);
		} else {
			this.calculateHeatMapData(20);
		}
	}

	convertToTimerFormat(seconds: number) {
		if (seconds < 3600) {
			// Display "mm:ss" format for the first 60 minutes
			const minutes = Math.floor(seconds / 60);
			const formattedSeconds = (seconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			return `${formattedMinutes}:${formattedSeconds}`;
		} else {
			// After 60 minutes, switch to "hh:mm:ss" format
			const hours = Math.floor(seconds / 3600);
			const remainingSeconds = seconds % 3600;
			const minutes = Math.floor(remainingSeconds / 60);
			const formattedSeconds = (remainingSeconds % 60).toString().padStart(2, "0");
			const formattedMinutes = minutes.toString().padStart(2, "0");
			const formattedHours = hours.toString().padStart(2, "0");
			return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
		}
	}
}
